(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["porin-reviews"] && !Shopify.designMode) return;
  try {
    const reviewForm = document.getElementById('PorinReviewForm');
if (reviewForm && reviewForm.querySelector('[role=status], [role=alert]')) reviewForm.closest('details').open = true;
  } catch(e) { console.error(e); }
})();

})();
